module.exports = __webpack_public_path__ + "media/flags/ki-92b18775.svg";